import httpClient from "./httpClient";

const GetCertificate = (req) => {
  // Create params
  const params = new URLSearchParams();
  if (req.lang) {
    params.append("lang", req.lang);
  }
  if (req.date) {
    params.append("date", req.date);
  }
  if (req.ref_no) {
    params.append("ref_no", req.ref_no);
  }
  // Call GetCertificate API
  return httpClient.get(`/GetCertificates?${params.toString()}`);
};

const GetInvestCert = (req) => {
  console.log(req);
  console.log("-------------2-");

  // สร้าง object body
  const body = {};
  if (req.AsofDate) body.AsofDate = req.AsofDate;
  if (req.REFNO) body.REFNO = req.REFNO;
  if (req.FULLNAME) body.FULLNAME = req.FULLNAME;

  // POST request ส่ง body เป็น JSON
  return httpClient.post("/get-invest-cert", body);
};



const DownloadCertificate = (req) => {
  // Create params
  const params = new URLSearchParams();
  if (req.lang) {
    params.append("lang", req.lang);
  }
  if (req.prefix) {
    params.append("prefix", req.prefix);
  }
  if (req.first_name) {
    params.append("first_name", req.first_name);
  }
  if (req.last_name) {
    params.append("last_name", req.last_name);
  }
  if (req.date) {
    params.append("date", req.date);
  }
  if (req.currency) {
    params.append("currency", req.currency);
  }
  if (req.certificate_type) {
    params.append("certificate_type", req.certificate_type);
  }
  if (req.certificate_for) {
    params.append("certificate_for", req.certificate_for);
  }
  if (req.ref_no) {
    params.append("ref_no", req.ref_no);
  }
  if (req.securities_symbol && req.securities_symbol.length > 0) {
    req.securities_symbol.forEach((symbol) => {
      params.append("securities_symbol", symbol);
    });
  }
  // Call DownloadCertificate API
  return httpClient.get(`/DownloadCertificatePDF?${params.toString()}`, {
    responseType: "arraybuffer",
  });
};

export default {
  GetCertificate,
  DownloadCertificate,
  GetInvestCert,
};
